import storage from "./storage";

const setItem = (key, value) => {
  storage[key] = value;
  window.dispatchEvent(new CustomEvent(key, { detail: value }));
};

export default setItem;
